import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EventbriteRegular from './eventbrite-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EventbriteRegular {...validProps} />;
}
SvgComponent.iconName = 'eventbriteRegular';

export const EventBriteRegularIcon = svgIconWrapper(SvgComponent);
